exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".edit-container[data-v-e95e46d0]{width:100%;height:100%;display:-webkit-box;display:-ms-flexbox;display:flex}.edit-container .left-side[data-v-e95e46d0]{width:300px;padding:10px 10px 0px 10px;background:#eeeeee}.edit-container .left-side .left-side-top[data-v-e95e46d0]{height:30px}.edit-container .right-side[data-v-e95e46d0]{padding:20px 0px 0px 20px}\n", ""]);

// exports
